import actions from "./actions";

const initState = {
    deviceEvents: [],
    errors: {},
    loading: false,
    editView: false,
}

export default function deviceEventsReducer(state = initState, action) {
    switch(action.type) {
        case actions.FETCH_DEVICE_EVENTS: 
            return {
                ...state,
                loading: true,
                editView: false,
            };
        case actions.FETCH_DEVICE_EVENTS_SUCCESS:
            return {
                ...state,
                deviceEvents: action.deviceEvents,
                loading: false,
                editView: false,
            };
        case actions.FETCH_DEVICE_EVENTS_ERROR:
            return {
                ...state,
                deviceEvents: [],
                loading: false,
                editView: false,
            };
        default:
            return state;
    }
}